// ✅ src/data/standardsData.js

import zoho from "../assets/standards/cmmi3.png";
import salesforce from "../assets/standards/27001.png";
import aws from "../assets/standards/9001.png";

const standardsData = [
  {
    id: 1,
    name: "cmmi3 Dev",
    description:
      "Zoho is a global technology company offering cloud software and business tools trusted by millions of users worldwide.",
    logo: zoho,
  },
  {
    id: 4,
    name: "ISO 27001:2022, ISMS",
    description:
      "Salesforce is the world’s #1 CRM platform, helping organizations streamline customer engagement and sales automation.",
    logo: salesforce,
  },
  {
    id: 5,
    name: "ISO 9001 QMS",
    description:
      "AWS provides reliable, scalable, and inexpensive cloud computing services trusted by enterprises worldwide.",
    logo: aws,
  },
];

export default standardsData;
